// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { ITemplateMethod } from "@/types/templates";
import { EMessageChannel } from "@/types/messaging";
/**
 * The order a template's stored method is chosen in. It is data, not display:
 * it keeps the order templates were saved with before the channel order
 * (`MESSAGE_TEMPLATE_METHODS`) changed, so saving a template stores the same method.
 */
var STORED_METHOD_ORDER = [
    ITemplateMethod.EMAIL,
    ITemplateMethod.SMS,
    ITemplateMethod.WHATSAPP,
    ITemplateMethod.VIBER,
    ITemplateMethod.MESSENGER,
    ITemplateMethod.DOCUMENT,
];
/** The method a template is stored under: the first selected one. */
export var primaryTemplateMethod = function (selected) { return STORED_METHOD_ORDER.find(function (method) { return selected === null || selected === void 0 ? void 0 : selected[method]; }); };
/** Whether a template has content for `method`. */
export var templateOffersMethod = function (row, method) {
    var _a;
    var selected = (_a = row.template) === null || _a === void 0 ? void 0 : _a.selected_methods;
    if (selected && Object.values(selected).some(Boolean)) {
        return selected[method] === true;
    }
    return row.communication_method === method;
};
export var methodChannel = function (method) {
    switch (method) {
        case ITemplateMethod.EMAIL:
            return EMessageChannel.EMAIL;
        case ITemplateMethod.SMS:
            return EMessageChannel.SMS;
        case ITemplateMethod.WHATSAPP:
            return EMessageChannel.WHATSAPP;
        case ITemplateMethod.VIBER:
            return EMessageChannel.VIBER;
        case ITemplateMethod.MESSENGER:
            return EMessageChannel.MESSENGER;
        case ITemplateMethod.DOCUMENT:
            return null;
    }
};
/** Key of a method's content in the template JSON. */
export var templateContentKey = function (method) {
    switch (method) {
        case ITemplateMethod.EMAIL:
            return "email";
        case ITemplateMethod.SMS:
            return "sms";
        case ITemplateMethod.WHATSAPP:
            return "whatsapp";
        case ITemplateMethod.VIBER:
            return "viber";
        case ITemplateMethod.MESSENGER:
            return "messenger";
        case ITemplateMethod.DOCUMENT:
            return "document";
    }
};
